module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/Imagem-edc7c21829cc24fe343cb979457b8a96.png";